module.exports = __webpack_public_path__ + "static/media/rahul.7eae7404.png";